export const recordLogListSubscription = `
    subscription record_log_list($filter: String, $limit: Int, $offset: Int, $order: String) {
        record_log_list(filter: $filter, limit: $limit, offset: $offset, order: $order) {
            record_log_count
            record_log_list {
                created_at
                data
                id
                record_id
                record_id_record {
                    id
                    name
                    record_type
                }
                record_log_record_plain_list_record_log_id(limit:2, order:"+id",offset:0) {
                    reference_record_by
                    reference_record_select
                    reference_record_type
                }
                subject
                level
            }
        }
    }
`;

export const clearLogsMutation = (type) => `mutation ($id: String!) {
  clear_${type}_logs(id: $id)}`;
